import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/layer/ai/layer.ai.mutation.gql"
import type {
  LayerAiAssistMutation,
  LayerAiAssistMutationVariables,
} from "@/v2-backoffice-client/layer/ai/__types__/layer.ai.mutation"

type Options = MutationHookOptions<
  LayerAiAssistMutation,
  LayerAiAssistMutationVariables
>

export function useLayerAiAssistMutation(options?: Options) {
  return useMutation<LayerAiAssistMutation, LayerAiAssistMutationVariables>(
    mutation,
    options,
  )
}
